const PATH_TEASER_IMG = "/images/teaser";
export const LAYOUT = {
    width: 7.5,
    height: 10.83,
    margin: 0.5
};

export const TITLE_TO_BODY = 0.33;
export const SECTION_SPACING = 0.28;
export const LINE_H = 0.24;
export const MIN_H = 0.72;
export const MAX_H = 2.2;
export const SLIDE_BOTTOM_SAFE = 10;
export const SECTION_TITLE_HEIGHT = 0.33;
export const BULLET_LINE_HEIGHT = 0.2;
export const TECH_FIELD_HEIGHT = 0.18;
export const MIN_SECTION_HEIGHT = 0.4;

export const COLORS = {
    primary: "#012A12",
    secondary: "#004B20",
    accent: "#279D59",
    lightPrimary: "#3ed881",
    red: "#FF4F30",
    redLight: "#FFC6BC",
    white: "#FFFFFF",
    badgeGray: "#4E6155",
    bulletGray: "#d8d8d8"
};

export const FONTS = {
    title: "Montserrat, Aptos Display, Arial",
    body: "Inter, Arial"
};

export const technologyTitles = {
    'solar': 'Solar PV Details & Design',
    'wind': 'Windpower Details & Design',
    'bess': 'BESS Details & Design',
    'hydrogen': 'Hydrogen Details & Design',
    'biogas': 'Biogas Details & Design',
    'hydropower': 'Hydropower Details & Design',
}

export const IMAGE_PATHS: any = {
  // Logos principales
  logos: {
    white: `${PATH_TEASER_IMG}/logos/Logo_Blanco_Slogan_sin_fondo.png`,
    black: `${PATH_TEASER_IMG}/logos/Logo_Verde_sin_fondo.png`,
  },

  icons: {
    folder: `${PATH_TEASER_IMG}/icons/misc/folder-open.png`,
    cable: `${PATH_TEASER_IMG}/icons/misc/cable.png`,
    info: `${PATH_TEASER_IMG}/icons/misc/info.png`,
    list: `${PATH_TEASER_IMG}/icons/misc/list.png`,
    settings: `${PATH_TEASER_IMG}/icons/misc/settings.png`,
    land: `${PATH_TEASER_IMG}/icons/misc/trees.png`,
    globe: `${PATH_TEASER_IMG}/icons/misc/globe.png`,
    mail: `${PATH_TEASER_IMG}/icons/misc/mail.png`,
    click: `${PATH_TEASER_IMG}/icons/misc/mouse-pointer-click.png`,
    pie: `${PATH_TEASER_IMG}/icons/misc/chart-pie.png`,
    chart: `${PATH_TEASER_IMG}/icons/misc/chart-column-increasing.png`,
    users: `${PATH_TEASER_IMG}/icons/misc/users.png`
  },

  advisors: {
    legal: `${PATH_TEASER_IMG}/advisors/legal.png`,
    financial: `${PATH_TEASER_IMG}/advisors/financial.png`,
    technical: `${PATH_TEASER_IMG}/advisors/technical.png`,
    epc: `${PATH_TEASER_IMG}/advisors/epc.png`,
  },

  technologies: {
    green: {
      solar: `${PATH_TEASER_IMG}/icons/technologies/solar-green.png`,
      bess: `${PATH_TEASER_IMG}/icons/technologies/bess-green.png`,
      wind: `${PATH_TEASER_IMG}/icons/technologies/wind-green.png`,
      hydrogen: `${PATH_TEASER_IMG}/icons/technologies/hydrogen-green.png`,
      biogas: `${PATH_TEASER_IMG}/icons/technologies/biogas-green.png`,
      hidropower: `${PATH_TEASER_IMG}/icons/technologies/hidropower-green.png`,
      datacenter: `${PATH_TEASER_IMG}/icons/technologies/datacenter-green.png`,
      topco: `${PATH_TEASER_IMG}/icons/technologies/topco-green.png`,
    },
    black: {
      solar: `${PATH_TEASER_IMG}/icons/technologies/solar-black.png`,
      bess: `${PATH_TEASER_IMG}/icons/technologies/bess-black.png`,
      wind: `${PATH_TEASER_IMG}/icons/technologies/wind-black.png`,
      hydrogen: `${PATH_TEASER_IMG}/icons/technologies/hydrogen-black.png`,
      biogas: `${PATH_TEASER_IMG}/icons/technologies/biogas-black.png`,
      hidropower: `${PATH_TEASER_IMG}/icons/technologies/hidropower-black.png`,
      datacenter: `${PATH_TEASER_IMG}/icons/technologies/datacenter-black.png`,
      topco: `${PATH_TEASER_IMG}/icons/technologies/topco-black.png`,
    },
  },
} as const;
